<template>
  <div class="FlyingUs">
    <div class="container_w">
        <div class="so_title clear">
            <div class="left">Flying with Us</div>
            <!-- <span class="right">
                <a :href="flyingWithUsAdmore.linkUrl?flyingWithUsAdmore.linkUrl:'javascript:;'">View More</a>
            </span> -->
        </div>
        <ul class="clear">
            <router-link 
            :to="{path:'/interlayer',query: {list: flyingWithUsAd1}}" v-if="flyingWithUsAd1.fileText">
                <li class="left" :style="furl1">
                    <h3>{{flyingWithUsAd1.title}}</h3>
                    <p>{{flyingWithUsAd1.remark}}</p>
                    <i></i>
                </li>
            </router-link>
            <a :href="flyingWithUsAd1.linkUrl?flyingWithUsAd1.linkUrl:'javascript:;'" v-else>
                <li class="left" :style="furl1">
                    <h3>{{flyingWithUsAd1.title}}</h3>
                    <p>{{flyingWithUsAd1.remark}}</p>
                    <i></i>
                </li>
            </a>

            <router-link 
            :to="{path:'/interlayer',query: {list: flyingWithUsAd2}}" v-if="flyingWithUsAd2.fileText">
                <li class="left" :style="furl2">
                    <h3>{{flyingWithUsAd2.title}}</h3>
                    <p>{{flyingWithUsAd2.remark}}</p>
                    <i></i>
                </li>
            </router-link>
            <a :href="flyingWithUsAd2.linkUrl?flyingWithUsAd2.linkUrl:'javascript:;'" v-else>
                <li class="left" :style="furl2">
                    <h3>{{flyingWithUsAd2.title}}</h3>
                    <p>{{flyingWithUsAd2.remark}}</p>
                    <i></i>
                </li>
            </a>
            
            <router-link 
            :to="{path:'/interlayer',query: {list: flyingWithUsAd3}}" v-if="flyingWithUsAd3.fileText">
                <li class="left" :style="furl3">
                    <h3>{{flyingWithUsAd3.title}}</h3>
                    <p>{{flyingWithUsAd3.remark}}</p>
                    <i></i>
                </li>
            </router-link>
            <a :href="flyingWithUsAd3.linkUrl?flyingWithUsAd3.linkUrl:'javascript:;'" v-else>
                <li class="left" :style="furl3">
                    <h3>{{flyingWithUsAd3.title}}</h3>
                    <p>{{flyingWithUsAd3.remark}}</p>
                    <i></i>
                </li>
            </a>
            
        </ul>
    </div>
  </div>
</template>

<script>
export default {
  components: {
    
  },
  name: 'FlyingUs',
  data () {
    return {
        specialList:[{id:1},{id:1},{id:1},{id:1},{id:1},{id:1}],
        flyingWithUsAd1:{},
        flyingWithUsAd2:{},
        flyingWithUsAd3:{},
        flyingWithUsAdmore:{},
        furl1:{},
        furl2:{},
        furl3:{},
    }
  },
  props: {

  },
  watch: {

  },
  methods: {
    
  },
  filters: {

  },
  computed: {

  },
  created () {
    let OfficeID = this.$Utils.getSession('COUNTRY_OfficeID')
    let flyingWithUsAd1 = {}
    let flyingWithUsAd2 = {}
    let flyingWithUsAd3 = {}
    let flyingWithUsAdmore = {}
    console.log(ADJSON,'0000')
    ADJSON.forEach((i)=>{
        if(i.advPositionId ==  "flyingWithUsAd1" && i.officeIdStr.indexOf(OfficeID)>-1 ){
            flyingWithUsAd1 = i
        }else if(i.advPositionId ==  "flyingWithUsAd2" && i.officeIdStr.indexOf(OfficeID)>-1 ){
            flyingWithUsAd2 = i
        }else if(i.advPositionId ==  "flyingWithUsAd3" && i.officeIdStr.indexOf(OfficeID)>-1 ){
            flyingWithUsAd3 = i
        }else if(i.advPositionId == "flyingWithUsViewMore"&& i.officeIdStr.indexOf(OfficeID)>-1){
            flyingWithUsAdmore = i
        }
    })
    this.flyingWithUsAd1 = flyingWithUsAd1
    this.flyingWithUsAd2 = flyingWithUsAd2
    this.flyingWithUsAd3 = flyingWithUsAd3
    this.flyingWithUsAdmore = flyingWithUsAdmore
    this.furl1 = {
        background:`linear-gradient(180deg,rgba(255,255,255,1) 0%,rgba(255,255,2055,1) 29%,rgba(255,255,255,0) 100%),url(${flyingWithUsAd1.imgUrl}) no-repeat center`,
        backgroundSize:'100% 100%'
    }
    this.furl2 = {
        background:`linear-gradient(180deg,rgba(255,255,255,1) 0%,rgba(255,255,2055,1) 51%,rgba(255,255,255,0) 100%),url(${flyingWithUsAd2.imgUrl}) no-repeat center`,
        backgroundSize:'100% 100%'
    }
    this.furl3 = {
        background:`linear-gradient(180deg,rgba(255,255,255,1) 0%,rgba(255,255,2055,1) 51%,rgba(255,255,255,0) 100%),url(${flyingWithUsAd3.imgUrl}) no-repeat center`,
        backgroundSize:'100% 100%'
    }
  },
  mounted () {
    
  },
  destroyed () {
    
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
    .FlyingUs{
        padding-top: 40px;
        background:#fff;
        .container_w{
            .so_title{
                line-height: 32px;
                margin-bottom: 32px;
                .left{
                    font-size:24px;
                    color:rgba(51,51,51,1);
                }
                span{
                    font-size:14px;
                    color:rgba(216,0,15,1);
                    line-height:16px;
                    margin-top: 8px;
                    cursor: pointer;
                    &::after{
                        content: '';
                        float: right;
                        width: 16px;
                        height: 16px;
                        background: url(../../assets/home/icon_com_sj_morered.png) no-repeat center;
                        background-size: 100% 100%;
                    }
                }
            }
            ul{
                margin-bottom: 96px;
                a{
                    li{
                        // background:linear-gradient(180deg,rgba(255,255,255,1) 0%,rgba(255,255,2055,1) 51%,rgba(255,255,255,0) 100%),url(http://www.sichuanair.com/theme/scal_201607/img/homepage/remad_products/pdt_1_lower_01.jpg);
                        background-position: center;
                        background-size: 100% 100%;
                        background-repeat: no-repeat;
                        border:1px solid rgba(236,238,240,1);
                    }
                    &:first-child{
                        li{
                            width:736px;
                            height:430px;
                            border-radius:10px;
                            margin-right: 32px;
                            padding: 32px;
                            h3{
                                font-size:32px;
                                color:rgba(187,144,74,1);
                                line-height:38px;
                                margin-bottom: 16px;
                            }
                            p{
                                font-size:14px;
                                color:rgba(128,128,128,1);
                                line-height:16px;
                            }
                        }
                    }
                    &:nth-child(2),&:nth-child(3){
                        li{
                            width:352px;
                            height:198px;
                            border-radius:8px;
                            padding: 16px;
                            h3{
                                font-size:18px;
                                color:rgba(187,144,74,1);
                                line-height:23px;
                                margin-bottom: 8px;
                            }
                            p{
                                font-size:14px;
                                color:rgba(128,128,128,1);
                                line-height:16px;
                            }
                        }
                    }
                    &:nth-child(2){
                        li{
                            margin-bottom: 32px;
                        }
                    }
                }
                
            }
            
        }
        
    }
</style>
